import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { WEBSITE_NAVIGATION_EVENT } from '../../utils/websiteVersion';

export default function WebsiteVersionNavigation() {
  const location = useLocation();
  useEffect(() => {
    window.dispatchEvent(new Event(WEBSITE_NAVIGATION_EVENT));
  }, [location.pathname, location.search]);
  return null;
}
